import TeamcityLogo from '@jetbrains/logos/teamcity/teamcity.svg'
import Logo from '@jetbrains/ring-ui/components/header/logo'
import * as React from 'react'

import {isPipelinesEnabledInExclusiveMode} from '../../../pages/PipelinesPages/utils/featureToggles'
import {LINKS} from '../Header.constants'

import HeaderLinkHost from './Links.host'

function HomeLink() {
  const renderLogo = React.useCallback(
    () => <Logo glyph={TeamcityLogo} data-ignore-dark-theme-adapter />,
    [],
  )
  const linkLogo = isPipelinesEnabledInExclusiveMode ? LINKS.pipelines : LINKS.overview

  return (
    <HeaderLinkHost to={linkLogo} title={'Home'}>
      {renderLogo}
    </HeaderLinkHost>
  )
}

export default React.memo(HomeLink)
